import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import "../../assets/scss/home/hero.scss"
// import Drip from './Drip';



function HomeHero(props: any) {
    return (
        <div className="group bg-red">
            <Container className="home-hero">
                <Row className="container-red h-100  o-visible">
                    <Col className="h-100 d-flex"
                        md={{ span: 8, offset: 2 }}
                    >
                        <div className="hero-text" >
                            <h1>Hello.</h1>
                            <h1 className="color-white">I am</h1>
                            <h1 className="color-white"> Ollie</h1>
                        </div>
                    </Col>
                </Row>
            </Container>

            {/* <Drip divName="containerDrip" /> */}

        </div>
    );
}

export default HomeHero;
